module.exports = __webpack_public_path__ + "static/media/rm_06-03.2d389c00.png";